import { render, staticRenderFns } from "./EventDetail.vue?vue&type=template&id=b24be5d2&scoped=true&"
import script from "./EventDetail.vue?vue&type=script&lang=js&"
export * from "./EventDetail.vue?vue&type=script&lang=js&"
import style0 from "./EventDetail.vue?vue&type=style&index=0&id=b24be5d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b24be5d2",
  null
  
)

export default component.exports